function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M8.7,80.6l22.6-58.8h8.4l24.1,58.8h-8.9l-6.9-17.8H23.5L17,80.6H8.7z M25.7,56.5h19.9l-6.1-16.3 c-1.9-4.9-3.3-9-4.2-12.2c-0.7,3.8-1.8,7.5-3.2,11.2L25.7,56.5z"
}), React.createElement("path", {
  className: "st0",
  d: "M96.7,80.6v-5.4c-2.7,4.2-6.7,6.3-11.9,6.3c-3.4,0-6.5-0.9-9.4-2.8c-2.8-1.9-5.1-4.5-6.6-7.8 s-2.3-7.2-2.3-11.6c0-4.3,0.7-8.1,2.1-11.6c1.4-3.5,3.5-6.1,6.4-8c2.8-1.8,6-2.8,9.5-2.8c2.6,0,4.9,0.5,6.9,1.6 c2,1.1,3.6,2.5,4.9,4.2V21.8h7.2v58.8H96.7z M73.9,59.4c0,5.5,1.1,9.5,3.5,12.2c2.3,2.7,5,4.1,8.1,4.1c3.2,0,5.8-1.3,8-3.9 c2.2-2.6,3.3-6.5,3.3-11.8c0-5.8-1.1-10.1-3.4-12.8c-2.2-2.7-5-4.1-8.3-4.1c-3.2,0-5.9,1.3-8,3.9C75,49.6,73.9,53.7,73.9,59.4z"
}), React.createElement("path", {
  className: "st0",
  d: "M142.4,80.6v-5.4c-2.7,4.2-6.7,6.3-11.9,6.3c-3.4,0-6.5-0.9-9.4-2.8c-2.8-1.9-5.1-4.5-6.6-7.8 s-2.3-7.2-2.3-11.6c0-4.3,0.7-8.1,2.1-11.6c1.4-3.5,3.5-6.1,6.4-8c2.8-1.8,6-2.8,9.5-2.8c2.6,0,4.9,0.5,6.9,1.6 c2,1.1,3.6,2.5,4.9,4.2V21.8h7.2v58.8H142.4z M119.6,59.4c0,5.5,1.1,9.5,3.5,12.2c2.3,2.7,5,4.1,8.1,4.1c3.2,0,5.8-1.3,8-3.9 c2.2-2.6,3.3-6.5,3.3-11.8c0-5.8-1.1-10.1-3.4-12.8c-2.2-2.7-5-4.1-8.3-4.1c-3.2,0-5.9,1.3-8,3.9C120.7,49.6,119.6,53.7,119.6,59.4 z"
}), React.createElement("path", {
  className: "st0",
  d: "M275.3,80.6V21.8H287l13.9,41.6c1.3,3.9,2.2,6.8,2.8,8.7c0.7-2.1,1.7-5.3,3.1-9.4l14.1-40.9h10.5v58.8h-7.5 V31.4l-17.1,49.2h-7l-17-50.1v50.1H275.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M370.9,75.4c-2.7,2.3-5.2,3.9-7.7,4.8s-5.1,1.4-8,1.4c-4.7,0-8.3-1.1-10.8-3.4c-2.5-2.3-3.8-5.2-3.8-8.8 c0-2.1,0.5-4,1.4-5.7c0.9-1.7,2.2-3.1,3.7-4.2s3.3-1.8,5.2-2.4c1.4-0.4,3.6-0.7,6.4-1.1c5.8-0.7,10.1-1.5,12.9-2.5c0-1,0-1.6,0-1.9 c0-2.9-0.7-5-2-6.2c-1.8-1.6-4.6-2.4-8.2-2.4c-3.4,0-5.9,0.6-7.5,1.8c-1.6,1.2-2.8,3.3-3.6,6.3l-7.1-1c0.6-3,1.7-5.5,3.2-7.3 c1.5-1.9,3.6-3.3,6.4-4.3c2.8-1,6-1.5,9.7-1.5c3.6,0,6.6,0.4,8.9,1.3c2.3,0.9,3.9,1.9,5,3.2c1.1,1.3,1.8,2.9,2.2,4.9 c0.2,1.2,0.4,3.5,0.4,6.7v9.6c0,6.7,0.2,11,0.5,12.7c0.3,1.8,0.9,3.5,1.8,5.1h-7.5C371.6,79.1,371.1,77.4,370.9,75.4z M370.3,59.2 c-2.6,1.1-6.6,2-11.8,2.7c-3,0.4-5.1,0.9-6.3,1.4c-1.2,0.5-2.2,1.3-2.8,2.3c-0.7,1-1,2.2-1,3.4c0,1.9,0.7,3.5,2.2,4.8 c1.5,1.3,3.6,1.9,6.4,1.9c2.8,0,5.3-0.6,7.4-1.8c2.2-1.2,3.8-2.9,4.8-5c0.8-1.6,1.2-4,1.2-7.2V59.2z"
}), React.createElement("path", {
  className: "st0",
  d: "M388.7,80.6V38h6.5v6.5c1.7-3,3.2-5,4.6-6c1.4-1,2.9-1.4,4.6-1.4c2.4,0,4.9,0.8,7.4,2.3l-2.5,6.7 c-1.8-1-3.5-1.6-5.3-1.6c-1.6,0-3,0.5-4.3,1.4c-1.3,0.9-2.2,2.3-2.7,4c-0.8,2.6-1.2,5.4-1.2,8.4v22.3H388.7z"
}), React.createElement("path", {
  className: "st0",
  d: "M416.2,80.6V21.8h7.2v33.5L440.5,38h9.3l-16.3,15.8l17.9,26.8h-8.9l-14.1-21.8l-5.1,4.9v16.9H416.2z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st1",
  d: "M191.5,31.5c-3.1,0-5.5,1.7-7.4,5.2c-1.9,3.5-2.8,8.7-2.8,15.7c0,6.9,1,12.1,2.9,15.7c1.9,3.6,4.4,5.3,7.3,5.3 c3,0,5.4-1.8,7.3-5.3c1.9-3.5,2.8-8.8,2.8-15.9c0-7-0.9-12.2-2.8-15.6C197.1,33.2,194.6,31.5,191.5,31.5z"
}), React.createElement("path", {
  className: "st1",
  d: "M168.3,2.2v94h85.2v-94H168.3z M204.5,75.6c-3.2,5.5-7.5,8.3-13,8.3c-5.5,0-9.8-2.8-13.1-8.3 c-3.2-5.5-4.8-13.1-4.8-22.8c0-6.2,0.6-11.4,1.7-15.6c0.8-3.1,2-5.9,3.4-8.3c1.4-2.5,3-4.3,4.8-5.5c2.3-1.6,4.9-2.4,7.9-2.4 c5.4,0,9.8,2.8,13,8.3c3.3,5.6,4.9,13.3,4.9,23.2C209.4,62.4,207.8,70,204.5,75.6z M238.8,82.9l-10.1-28.5l-6,10.2v18.4h-7.4V22.1 h7.4v27l15-27h10l-13.9,23.7l14.6,37.1H238.8z"
}));

var SvgAddOkMarkIcon = function SvgAddOkMarkIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 459 98.8",
    style: {
      enableBackground: "new 0 0 459 98.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAddOkMarkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add-ok-mark-icon.3a60d836.svg";
export { ForwardRef as ReactComponent };